// @ vendor
const classnames = require('classnames');

// @ utilities
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');

// @ constant
const { EURO_TEXT, THIRD_STEP, FOURTH_STEP } = require('constants/index');
const { INSURANCE_STATE, PAYMENT_TYPE } = require('../../insuranceConstants/insuranceRequestHome');

const formatCurrency = (amount, decimalsLength = 0) => {
    return getFormattedString({
        amount: amount,
        currency: EURO_TEXT,
        decimalsLength
    });
}

const insuranceRequestBuildPrimeItem = (immInsuranceState, immInsuranceWizardState, hasSimulation, hasSimulationChanged, isFromSummary = false, isRnc = false) => {
    const immStep3 = immInsuranceWizardState.getIn(['steps', THIRD_STEP]);
    const currentStep = isRnc ? THIRD_STEP : FOURTH_STEP;
    const stepData = immInsuranceWizardState.getIn(['steps', currentStep]);
    const paymentType = stepData.get('paymentType') || '';
    const plan = isRnc ? stepData.get('insurancePlan') : immStep3.get('insurancePlan') || '';
    const primePrice = immInsuranceState.getIn(['data', 'prime', `totalImport${toFirstUppercase(plan)}`]);
    const primePriceQuotation = immStep3.getIn(['quotationData', plan.toLowerCase(), 'totalImport']);
    const invalidSimulation = immInsuranceState.getIn(['data', 'insuranceState']) === INSURANCE_STATE.INVALID;
    const discountPrice = stepData.getIn(['pricing', paymentType.toLowerCase(), plan.toLowerCase(), 'totalImport']);
    let priceFormattedText = formatText('insuranceRequestHome-summaryToBeDefined');
    let disabledRnc = true;

    if (!hasSimulationChanged && !invalidSimulation) {
        if (immInsuranceState.getIn(['data', 'content']) && !isRnc) {
            if (primePriceQuotation && paymentType === PAYMENT_TYPE.ANNUAL) {
                priceFormattedText = formatCurrency(primePriceQuotation, 2);
            } else if (!immInsuranceState.get('isFetching') && stepData.get('isFetchingPricing') && primePrice) {
                priceFormattedText = formatCurrency(primePrice, 2);
            } else if (!stepData.get('isFetchingPricing') && discountPrice) {
                priceFormattedText = formatCurrency(discountPrice, 2);
            }
        } else if (isRnc) {
            if (stepData.get('isFetchingPricing') && primePrice) {
                disabledRnc = false;
                if (discountPrice) {
                    priceFormattedText = formatCurrency(discountPrice, 2);
                } else {
                    priceFormattedText = formatCurrency(primePrice, 2);
                }
            } else if (!stepData.get('isFetchingPricing') && discountPrice) {
                disabledRnc = false;
                priceFormattedText = formatCurrency(discountPrice, 2);
            }

        }
    }

    const rncDisabledValidation = isRnc
        ? disabledRnc
        : !hasSimulation || hasSimulationChanged || invalidSimulation

    return {
        label: formatText('insuranceRequestHome-summaryPrime'),
        text: priceFormattedText,
        className: classnames({
            'insurance-request-compilation-card__text--important': hasSimulation && !hasSimulationChanged && !isFromSummary && !invalidSimulation,
            'insurance-request-compilation-card__text--disabled': rncDisabledValidation
        })
    };
}

module.exports = insuranceRequestBuildPrimeItem;